import get from 'lodash.get';

const getValue = (state, option, elementId, attribute) => {
  const currentValue = get(state, `${elementId}.${attribute}`);
  const computedValue =
    option.computeFallbackValue?.({
      option,
      elementId,
      attribute,
    }) || currentValue;

  return currentValue || computedValue;
};

const getOptionComputedAttributesValues = (state, option) => {
  const { attributes, elementIds } = option;

  return attributes.map((attribute) => {
    if (elementIds.length > 1) {
      return elementIds
        .map((elementId) => getValue(state, option, elementId, attribute))
        .filter((value) => value !== undefined);
    }

    return getValue(state, option, elementIds[0], attribute);
  });
};

export default getOptionComputedAttributesValues;
